module.exports = __webpack_public_path__ + "static/media/DSC_0309.b745f57a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0309.jpg
// module id = 664
// module chunks = 0